<button type="button" class="{{buttonClass}}" (click)="download(contentDownloading)" [innerHtml]="buttonLable"></button>

<ng-template #contentDownloading>
  Downloading file {{filename}} . . . {{downloadProgress}}%
  <p [style.width]="'100%'">
    <ngb-progressbar type="primary" [value]="downloadProgress" [height]="'10px'" [animated]="true"></ngb-progressbar>
  </p>
</ng-template>
